import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatStepperScrollerDirective } from './directive/mat-stepper-scroller.directive';
import { HelpGqlService, HelpApiService } from '..';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [MatStepperScrollerDirective],
  imports: [
    CommonModule,
    NgxMaskDirective,NgxMaskPipe,
  ],providers: [
    provideNgxMask()],
  exports:[
    MatStepperScrollerDirective
  ]
})
export class EbbIntegrationModule {}
